import { api } from "./axios";
const templateApi = {
  getTemplates: () => api.get("/email-templates"),
  getTemplate: (id: any) => api.get(`/email-templates/${id}`),
  createTemplate: (data:any) =>
    api.post("/email-templates/create", data),
  updateTemplate: (id: any, data:any) =>
    api.put(`/email-templates/update/${id}`, data),
  deleteTemplate: (id: number) => api.delete(`/email-templates/${id}`),
  setDefaultTemplate: (id: any) => api.put(`/email-templates/set-default/${id}`),
}

export default templateApi;